import api from 'utils/api-controller';
import Emitter from 'utils/event-emitter';
import utils from 'utils/utils';

var ctrl = {

  DATA_EVENT: 'system',

  emitter: new Emitter(),

  data: {},

  mixin: {

    componentDidMount() {
      ctrl.emitter.addEventListener(ctrl.DATA_EVENT,this.refreshSysData);
      if (!ctrl.data.pageHeader) ctrl.requestData(true);
    },

    componentWillUnmount(){
      ctrl.emitter.removeEventListener(ctrl.DATA_EVENT,this.refreshSysData);
    },

    refreshSysData(){
      this.setState({});
    }

  },

  requestData(isLoading){
    api.post('/parametros').success(function(data) {
      ctrl.data = utils.extend(ctrl.data, data);
      ctrl.emitter.emit(ctrl.DATA_EVENT);
    });
  }

};

module.exports = ctrl;


/** WEBPACK FOOTER **
 ** ./src/controllers/sys-ctrl.js
 **/